import { useRef as u, useEffect as s } from "react";
var o = function o(e, t) {
  var c = u(t);
  c.current = t, s(function () {
    var n = function n(r) {
      e.current && !e.current.contains(r.target) && c.current();
    };
    return document.addEventListener("click", n), function () {
      document.removeEventListener("click", n);
    };
  }, []);
};
export { o as default };